export default __webpack_public_path__ + "static/media/whatsapp.d4924730.svg";